import type { BlockDefinition } from '../types';
import { heroDarkSchema, type HeroDarkData } from './schema';
import { HeroDarkRenderer } from './Renderer';

export const heroDarkBlock: BlockDefinition<HeroDarkData> = {
  meta: {
    type: 'hero-dark',
    label: 'Hero principal con vídeo (v4)',
    description: 'Hero a pantalla completa con vídeo de fondo, h1 a 3 líneas (top/highlight/mute), CTAs y mini-stats con divisores.',
    category: 'hero',
    icon: 'play',
  },
  schema: heroDarkSchema,
  defaults: {
    videoSrc: '/media/hero-tech.mp4',
    posterSrc: '/media/hero-tech.jpg',
    h1Top: 'Construimos',
    h1Highlight: 'valor empresarial',
    h1Mute: 'en cada etapa.',
    sub: 'Aceleramos startups con capital, mentoría y red — y operamos la compraventa de empresas con asesoramiento M&A integral. Una plataforma. Dos servicios. Resultados medibles.',
    ctaPrimary: { label: 'Empieza ahora', href: '/contacto#agendar' },
    ctaSecondary: { label: '▶ Ver vídeo (90s)', href: '#video' },
    miniStats: [
      { value: '+50', label: 'startups aceleradas' },
      { value: '+120', label: 'operaciones M&A' },
      { value: '+€115M', label: 'movilizados' },
      { value: '★ 4,8', label: '+90 reseñas' },
    ],
    showScrollCue: true,
  },
  fields: [
    { name: 'videoSrc', label: 'URL vídeo MP4 fondo', type: 'url' },
    { name: 'posterSrc', label: 'Imagen poster (fallback)', type: 'url' },
    { name: 'h1Top', label: 'H1 línea 1 (top)', type: 'text', max: 160 },
    { name: 'h1Highlight', label: 'H1 línea 2 (highlight)', type: 'text', required: true, max: 160 },
    { name: 'h1Mute', label: 'H1 línea 3 (mute)', type: 'text', max: 160 },
    { name: 'sub', label: 'Subtítulo', type: 'textarea', max: 600 },
    {
      name: 'ctaPrimary',
      label: 'CTA primario',
      type: 'object',
      fields: [
        { name: 'label', label: 'Texto', type: 'text', required: true, max: 80 },
        { name: 'href', label: 'URL', type: 'url', required: true },
      ],
    },
    {
      name: 'ctaSecondary',
      label: 'CTA secundario',
      type: 'object',
      fields: [
        { name: 'label', label: 'Texto', type: 'text', required: true, max: 80 },
        { name: 'href', label: 'URL', type: 'url', required: true },
      ],
    },
    {
      name: 'miniStats',
      label: 'Mini stats (con divisores)',
      type: 'array',
      max: 6,
      itemFields: [
        { name: 'value', label: 'Valor', type: 'text', required: true, max: 40 },
        { name: 'label', label: 'Etiqueta', type: 'text', required: true, max: 120 },
      ],
    },
    { name: 'showScrollCue', label: 'Mostrar indicador Scroll', type: 'boolean' },
  ],
  Renderer: HeroDarkRenderer,
};

export { heroDarkSchema, HeroDarkRenderer };
export type { HeroDarkData };
